/**
 * GAイベントを送信
 *
 * @param {string} category GAカテゴリ
 * @param {string} action GAアクション
 * @param {string} label GAラベル
 * @param {Event} e イベント
 */
export function trEventBe(category, action, label, e = window.event) {
    const context = e ? e.currentTarget : window;

    if ('ga' in window && 'trEventBe' in window) {
        // GTMで提供されるtrEventBeを利用する
        window.trEventBe(context, category, action, label, e);
        return;
    }

    // eslint-disable-next-line no-console
    console.log('trEventBe: "%s", "%s", "%s", %o, %o', category, action, label, context, e);
}

export default {
    trEventBe,
};
